import PropTypes from 'prop-types';
import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

//Utils
import events from '../../../../lib/events.js';
import {dateTimeFormats} from 'helpers/constants';

//Components
import Loader from '../../../components/loader.jsx';
import PrintableFullReport from '../components/printableFullReport.jsx';
import ReportDropDown from '../components/reportDropDown.jsx';
import ReportTable from '../components/reportTable.jsx';
import {formatCurrency, formatStaticCurrency} from '../../../helpers/currencyHelper.jsx';

import {reportDateFormat} from 'helpers/constants';

import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

//Apis
import ReportApi from 'api/report';

let systemTypes = [];

let storeOptions = [];

function getAllStoreString() {
  return storeOptions
    .slice(1, storeOptions.length)
    .reduce((a,b) => a.concat([b.value]), [])
    .join();
}

function getAllSystemTypeString() {
  return systemTypes
    .slice(1, systemTypes.length)
    .reduce((a,b) => a.concat(b.value), [])
    .join();
}

class LostCustomerReport extends Component {
  constructor(props) {
    super(props);

    let {formatMessage} = this.props.intl;

    systemTypes = [
      {value: '', label: formatMessage({id: 'general.all.systems'})},
      {value: 1, label: formatMessage({id: 'general.pools'})},
      {value: 2, label: formatMessage({id: 'general.spas'})},
      {value: 3, label: formatMessage({id: 'general.swim.spas'})},
    ];

    storeOptions = [
      {value: '', label: formatMessage({id: 'general.all.stores'})},
    ];

    for (let i = 0; i < this.props.branchesFull.length; i++) {
      storeOptions.push({
        value: this.props.branchesFull[i].id,
        label: this.props.branchesFull[i].name,
      });
    }

    this.state = {
      loaded: true,
      summary: null,
      report: null,
      showNoDataMessage: false,

      start: moment().subtract(1, 'year').subtract(1, 'month'),
      end: moment().subtract(1, 'year'),
      since: moment().subtract(1, 'year').add(1, 'day'),
      store: storeOptions[0].value,
      systemType: systemTypes[0].value,

      systemTypeOptions: systemTypes,
      storeOptions: storeOptions,
    };
  }

  exportReport = () => {
    const {start, end, since} = this.state;

    ReportApi.getLostCustomerReportExport(
      this.props.intl.locale,
      this.state.store === '' ? getAllStoreString() : this.state.store,
      this.state.systemType === '' ? getAllSystemTypeString() : this.state.systemType,
      moment(start).format('YYYY-MM-DD'),
      moment(end).format('YYYY-MM-DD'),
      moment(since).format('YYYY-MM-DD')
    );
  };

  printSummary = table => {
    const {summary, start, end} = this.state;
    let {formatMessage} = this.props.intl;
    const columns = [
      {name: formatMessage({id: 'reports.total.lost.purchasing'}), key: 'total'},
      {name: formatMessage({id: 'reports.average.purchasing.value'}), key: 'avg_purchase_value'},
      {name: formatMessage({id: 'reports.total.lifetime.value'}), key: 'total_purchase_value'},
      {name: formatMessage({id: 'reports.average.purchase.lifespan'}), key: 'avg_purchase_lifespan'},
      {name: formatMessage({id: 'general.total.maintenance'}), key: 'total_maintenance_systems'},
    ];

    const tableColumns = [
      {name: formatMessage({id: 'general.primary.contact'}), key: 'name'},
      {name: formatMessage({id: 'general.last.purchased'}), key: 'last_purchase_date', format: function(i) { return moment(i, 'MMM D YYYY  h:mmA').format(dateTimeFormats.numeralDate);}},
      {name: formatMessage({id: 'general.analysis'}), key: 'analysis_count'},
      {name: formatMessage({id: 'reports.bioguard.purchases'}), key: 'invoice_count'},
      {name: formatMessage({id: 'reports.average.sales.analysis'}), key: 'avg_purchase_value_per_analysis'},
      {name: formatMessage({id: 'general.total.bioguard.sales'}), key: 'total_purchase_value'},
      {name: formatMessage({id: 'general.purchase.last.purchase'}), key: 'last_purchase_amount'},
    ];

    table.forEach((element) => {
      element.total_purchase_value = formatStaticCurrency(element.total_purchase_value);
      element.avg_purchase_value_per_analysis = formatStaticCurrency(element.avg_purchase_value_per_analysis);
      element.last_purchase_amount = formatStaticCurrency(element.last_purchase_amount);
    }, this);

    const formattedSummary = {
      total: summary.total,
      avg_purchase_value: formatStaticCurrency(summary.avg_purchase_value),
      total_purchase_value: formatStaticCurrency(summary.total_purchase_value),
      avg_purchase_lifespan: summary.avg_purchase_lifespan + ' ' + formatMessage({id: 'general.years'}),
      total_maintenance_systems: summary.total_maintenance_systems !== null ? summary.total_maintenance_systems : 0,
    };

    return (
      <PrintableFullReport
          end={end.format(dateTimeFormats.numeralDate)}
          endLabel={formatMessage({id: 'general.end.date'})}
          formatMessage={formatMessage}
          start={start.format(dateTimeFormats.numeralDate)}
          startLabel={formatMessage({id: 'general.start.date'})}
          summaryColumns={columns}
          summaryData={formattedSummary}
          tableColumns={tableColumns}
          tableData={table}
          title={formatMessage({id: 'reports.lost.purchasing.accounts'})}
      />
    );
  };

  resetFilters = () => {
    this.setState({
      start: moment().subtract(1, 'year').subtract(1, 'month'),
      end: moment().subtract(1, 'year'),
      since: moment().subtract(1, 'year').add(1, 'day'),
      store: storeOptions[0].value,
      systemType: systemTypes[0].value,
    });
  };

  updateReport = () => {
    const {start, end, since} = this.state;

    this.setState({
      loaded: false,
      summary: null,
    });

    ReportApi.getLostCustomerReportSummary(
      this.state.store === '' ? getAllStoreString() : this.state.store,
      this.state.systemType === '' ? getAllSystemTypeString() : this.state.systemType,
      moment(start).format('YYYY-MM-DD'),
      moment(end).format('YYYY-MM-DD'),
      moment(since).format('YYYY-MM-DD')
    ).then(data => {
      if(data && data.total > 0) {
        this.setState({summary: data});
      } else {
        this.setState({showNoDataMessage: true});
      }
    }).catch(err => {
      console.log(err);
      this.setState({showNoDataMessage: true});
    }).complete(() => {
      this.setState({
        loaded: true,
      });
    });

    ReportApi.getLostCustomerReport(
      this.state.store === '' ? getAllStoreString() : this.state.store,
      this.state.systemType === '' ? getAllSystemTypeString() : this.state.systemType,
      moment(start).format('YYYY-MM-DD'),
      moment(end).format('YYYY-MM-DD'),
      moment(since).format('YYYY-MM-DD')
    ).then(data => {
      this.setState({loaded: true, report: data});
    }).catch(err => {
      console.log(err);
    }).complete(() => {
      this.setState({
        loaded: true,
      });
    });
  };

  render() {

    let {formatMessage} = this.props.intl;

    const {
      start, end, since, store, storeOptions, systemType, systemTypeOptions, summary, loaded, report, showNoDataMessage,
    } = this.state;

    if (report && report.length) {
      report.map((row, i) => {
        if (row.name === null) {
          row.name = row.CustomerID;
        }
        return row;
      });
    }

    return (
      <div className='report-container'>
        <span className='description'><FormattedMessage id="reports.lost.purchasing.description" /></span>
        <div className="report-options">
          <div className="top-title-bar">
            <FormattedMessage id="general.report.options" />
          </div>
          <div className='select-options container'>
            <div className='row'>
              <label><FormattedMessage id="reports.purchase.between" /></label>
            </div>
            <div className='row'>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label><FormattedMessage id="general.date.from" /></label>
                  <div className='editable-datepicker'>
                    <DatePicker
                        selected={start}
                        dateFormat={reportDateFormat}
                        maxDate={end.clone().subtract(1, 'days')}
                        onChange={((e) => {
                          this.setState({start: e});
                        })}
                      />
                  </div>
                </div>
              </div>

              <div className='col-sm-3'>
                <div className='form-group'>
                  <label><FormattedMessage id="general.date.to" /></label>
                  <div className='editable-datepicker'>
                    <DatePicker
                      selected={end}
                      dateFormat={reportDateFormat}
                      minDate={start.clone()}
                      maxDate={since.clone().subtract(1, 'days')}
                      onChange={((e) => {
                        this.setState({end: e});
                      })}
                    />
                  </div>
                </div>
              </div>

              <div className='col-sm-3'>
                <div className='form-group'>
                  <label><FormattedMessage id="reports.no.purchase.since" /></label>
                  <div className='editable-datepicker'>
                    <DatePicker
                      selected={since}
                      dateFormat={reportDateFormat}
                      minDate={end.clone().add(1, 'days')}
                      onChange={((e) => {
                        this.setState({since: e});
                      })}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-sm-3'>
                <ReportDropDown value={store} label={formatMessage({id: 'general.store'})}
                  onChange={((e) => {
                    this.setState({store: e.target.value});
                  })}
                  options={storeOptions} />
              </div>

              <div className='col-sm-3'>
                <ReportDropDown
                  value={systemType}
                  label={formatMessage({id: 'general.system.type'})}
                  onChange={((e) => {
                    this.setState({systemType: e.target.value});
                  })}
                  options={systemTypeOptions} />
              </div>
            </div>
            <div className='manage-options'>
              <div className='col-sm-12 button-group'>
                <span className='reset-button pull-right' onClick={this.resetFilters}><FormattedMessage id="general.reset" /></span>
                <button className='btn btn-primary pull-right' onClick={this.updateReport}><FormattedMessage id="reports.update.summary" /></button>
              </div>
            </div>
          </div>
        </div>
        <Loader loaded={loaded}>
          {summary ? <div className='col-sm-12 summary-container'>
            <div className='row'>
              <h2>
                <FormattedMessage id="reports.report.summary" />
                <span className='sub-date'> | <FormattedMessage id="general.date.range"
                                                                values={{
                                                                  start: start.format(dateTimeFormats.numeralDate),
                                                                  end: end.format(dateTimeFormats.numeralDate),
                                                                }} /></span>
              </h2>
              <p className='description'><FormattedMessage id="reports.reveal.report.summary" /></p>
            </div>
            <div className='row'>
              <div className='col-sm-3 result'>
                <label><FormattedMessage id="reports.total.lost.purchasing" /></label>
                <div>{summary.total}</div>
              </div>
              <div className='col-sm-3 result'>
                <label><FormattedMessage id="reports.average.purchasing.value" /></label>
                <div>{summary.avg_purchase_value !== null ? formatCurrency(summary.avg_purchase_value) : '0.00'}</div>
              </div>
              <div className='col-sm-3 result'>
                <label><FormattedMessage id="reports.total.lifetime.value" /></label>
                <div>{summary.total_purchase_value !== null ? formatCurrency(summary.total_purchase_value) : '0.00'}</div>
              </div>
              <div className='col-sm-3 result'>
                <label><FormattedMessage id="reports.average.purchase.lifespan" /></label>
                <div>{summary.avg_purchase_lifespan !== null ? summary.avg_purchase_lifespan : '0'} <FormattedMessage id="general.years" /></div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-3 result'>
                <label><FormattedMessage id='general.total.maintenance' /></label>
                <div>{summary.total_maintenance_systems !== null ? summary.total_maintenance_systems : '0'}</div>
              </div>
            </div>
            <div className='pad-top'>
              { report ? <ReportTable data={report} headers={[
                {
                  label: formatMessage({id: 'general.primary.contact'}), key: 'name',
                  style: {width: '22%', 'textAlign': 'left'},
                  linkFunction: currow => '#customer/' + currow.CustomerID,
                },
                {
                  label: formatMessage({id: 'general.last.purchased'}), key: 'last_purchase_date',
                  style: {width: '13%', 'textAlign': 'left'},
                  format: i => moment(i, 'MMM D YYYY  h:mmA').format(dateTimeFormats.numeralDate),
                },
                {
                  label: formatMessage({id: 'general.analysis'}), key: 'analysis_count',
                  style: {width: '9%', 'textAlign': 'right'},
                },
                {
                  label: formatMessage({id: 'reports.bioguard.purchases'}), key: 'invoice_count',
                  style: {width: '17%', 'textAlign': 'right'},
                },
                {
                  label: formatMessage({id: 'reports.average.sales.analysis'}), key: 'avg_purchase_value_per_analysis',
                  style: {width: '13%', 'textAlign': 'right'},
                  format: formatCurrency,
                },
                {
                  label: formatMessage({id: 'general.total.bioguard.sales'}), key: 'total_purchase_value',
                  style: {width: '13%', 'textAlign': 'right'},
                  format: formatCurrency,
                },
                {
                  label: formatMessage({id: 'general.purchase.last.purchase'}), key: 'last_purchase_amount',
                  style: {width: '13%', 'textAlign': 'right'},
                  format: formatCurrency,
                },
              ]} /> : '' }
            </div>
          </div> :
          <div className='summary-container'>
            <h2><FormattedMessage id="reports.report.summary" /></h2>
            <p><FormattedMessage id="reports.reveal.report.summary" /></p>
            {showNoDataMessage ? <label className="report-no-data"><FormattedMessage id="reports.error.no.results" /></label> : ''}
            <div className="container-fluid custom-container-margins"><div /></div>
          </div>}
          <div className='col-sm-12 button-group shift-right'>
            <button className='btn btn-default pull-right' disabled={(report === null)} onClick={(() => {
              events.publish('print', this.printSummary(report));
            })}><FormattedMessage id="reports.print.summary" /></button>
            <button className='btn btn-primary pull-right' onClick={this.exportReport}><FormattedMessage id="reports.export.report" /></button>
          </div>
        </Loader>
      </div>
    );
  }
}

LostCustomerReport.propTypes = {
  branches: PropTypes.any,
};

export default injectIntl(LostCustomerReport);
